// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.realgrid-pre-wrap[data-v-c0a2aae0]{\n  white-space: pre-wrap\n}\n", ""]);
// Exports
module.exports = exports;
